import { getApiByWithoutId, postApi, putApiWithoutId } from "../../Shared/Services/RestService";
import {
  ChangePasswordRequest,
  ChangePasswordResponse,
  RecruiterSettings,
  RecruiterSettingsUpdate,
} from "../Types/RecruiterSettingsType";

/**
 * These routes carry no user id on purpose. The backend resolves the owner from the
 * access token, so there is nothing for a caller to tamper with.
 */
export const getRecruiterSettings = () => {
  return getApiByWithoutId<RecruiterSettings>("/recruiter/settings");
};

export const updateRecruiterSettings = (payload: RecruiterSettingsUpdate) => {
  return putApiWithoutId<RecruiterSettings>("/recruiter/settings", payload);
};

export const changeRecruiterPassword = (payload: ChangePasswordRequest) => {
  return postApi<ChangePasswordResponse>("/recruiter/settings/change-password", payload);
};
